interface ReportFooterProps {
  message?: string;
}

const ReportFooter = ({
  message,
}: ReportFooterProps) => {
  return (
    <div className="pt-2 mt-auto">
      {message && (
        <div className="text-center text-[9px] mb-1">
          <div className="text-red-600 text-[10px] leading-none">
            {message}
          </div>
        </div>
      )}

      <div className="border-t-[1px] border-black">
        <div className="flex items-center justify-between">
          {/* Left Logo */}
          <img
            src="/dano.png"
            alt="Dano Australia"
            className="h-16 object-contain"
          />

          {/* Center Logo */}
          <img
            src="/uwqs.png"
            alt="UWQS"
            className="h-12 object-contain"
          />

          {/* Right Logo */}
          <img
            src="/wiaa.png"
            alt="WIAA"
            className="h-20 object-contain"
          />
        </div>
      </div>
    </div>
  );
};

export default ReportFooter;